export enum HttpErrorCode {
  BadRequest = 400,
  Unauthorized = 401,
  NotFound = 404,
  InternalServerError = 500,
  ServiceUnavailable = 503,
  Forbidden = 403,
  TimeOut = 504,
  UniqueConstraint = 409,
  AlreadyExist = 422,
  PayloadToLarge = 413,
  Default = 0,
}

export enum ServerError {
  DUPLICATE_VALUE = 'DUPLICATE_VALUE',
  ENTITY_IN_USE = 'ENTITY_IN_USE',
  REFERENCE_NOT_FOUND = 'REFERENCE_NOT_FOUND',
  INVALID_FORM_PARAM = 'INVALID_FORM_PARAM',
}

export enum CustomHttpErrorCode {
  'UNAUTHORIZED' = HttpErrorCode.Unauthorized,
  'SERVICE_UNAVAILABLE' = HttpErrorCode.ServiceUnavailable,
  'INTERNAL_SERVER_ERROR' = HttpErrorCode.InternalServerError,
  'NOT_FOUND' = HttpErrorCode.NotFound,
  'INVALID_TOKEN' = HttpErrorCode.Unauthorized,
  'ACCESS_DENIED' = HttpErrorCode.Forbidden,
  'ALREADY_EXIST' = HttpErrorCode.AlreadyExist,
  'DUPLICATE_VALUE' = HttpErrorCode.UniqueConstraint,
  'MULTIPART_PAYLOAD_TOO_LARGE' = HttpErrorCode.PayloadToLarge,
  'INVALID_FORM_PARAM' = HttpErrorCode.BadRequest,
}

export type ErrorHandleMap = { [key in HttpErrorCode]: () => void };
